export enum AGENT_MODES {
  AGENT_MODE_DEFAULT,
  AGENT_MODE_BLIND_TRANSFERRING,
  AGENT_MODE_WARM_TRANSFER_INIT,
  AGENT_MODE_CONFERENCE_INIT
}
